var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"svg-icon",domProps:{"innerHTML":_vm._s(require(`!!html-loader!../../public/svg/${_vm.svgName}.svg`))}})
}
var staticRenderFns = []

export { render, staticRenderFns }